import { GetterTree } from 'vuex';
import RootState from '@/store/root_state';
import { PostgradEarlyGraduationEligibilityState } from './state';
import { ChimeraCourseModel } from '@/models/chimera/ChimeraCourseModel';
import { PostgradEarlyGraduationTrackingInformation } from '@/models/postgradEarlyGraduation/PostgradEarlyGraduationModel';

const getters: GetterTree<PostgradEarlyGraduationEligibilityState, RootState> = {
  earlyGraduationEligibilityByCourseId:
    (state) =>
    (courseId: number): boolean => {
      if (!courseId) return false;
      const eligibility = state.earlyGraduationEligibilityByCourseId[courseId];

      return eligibility;
    },
  earlyGraduationTrackings:
    (state) =>
    (
      currentChimeraCourse: ChimeraCourseModel | null,
    ): PostgradEarlyGraduationTrackingInformation | {} => {
      if (!currentChimeraCourse || !currentChimeraCourse.dexCourseId) return {};
      const eligibility =
        state.earlyGraduationEligibilityByCourseId[currentChimeraCourse.dexCourseId];

      const { contractAge, totalContractTime } = currentChimeraCourse.contractByUser!;
      return {
        early_graduation_course: eligibility,
        contract_days: contractAge.days,
        total_contract_days: totalContractTime.days,
      };
    },
};

export default getters;
